import { Option } from '@allesauto/core/searchDropdown';
import { Dispatch } from 'redux';

import { TagPayload } from '@/features/PCP/containers/FilterTagsContainer';
import { setPageNumber } from '@/store/redux/actions/pages/pcp';
import { IReduxActionProps } from '@/store/redux/Utils';

export const SET_FILTER_EQUIPMENT = 'SET_FILTER_EQUIPMENT';
export const DELETE_FILTER_EQUIPMENT = 'DELETE_FILTER_EQUIPMENT';
export const RESET_FILTER_EQUIPMENT = 'RESET_FILTER_EQUIPMENT';

export interface EquipmentFilterStateProps {
  aircon?: string[];
  comfort?: Option[];
  entertainment?: Option[];
  security?: Option[];
}

export const setEquipmentFilter = (value: EquipmentFilterStateProps) => {
  return (dispatch: Dispatch) => {
    dispatch(setPageNumber(1));

    dispatch({
      type: SET_FILTER_EQUIPMENT,
      payload: value,
    });
  };
};

export const deleteFilterEquipment = (payload: TagPayload) => {
  return (dispatch: Dispatch) => {
    dispatch(setPageNumber(1));

    dispatch({
      type: DELETE_FILTER_EQUIPMENT,
      payload,
    });
  };
};

export const resetFilterEquipment = (): IReduxActionProps => {
  return {
    type: RESET_FILTER_EQUIPMENT,
  };
};
